module.exports = __webpack_public_path__ + "img/icon-simple.128f3262.svg";